import { inject, Injectable } from '@angular/core';
import { StepResolverStrategy } from './step-resolver.strategy';
import { Step } from '../../types';
import { Observable, of } from 'rxjs';
import { ExtrasStepDefinitionService } from '../step-definition';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class ExtrasStepResolverService implements StepResolverStrategy {
  private readonly extrasStepDefinitionService = inject(ExtrasStepDefinitionService);

  resolve(activeFlow: Flow): Observable<Step> {
    return of(this.extrasStepDefinitionService.getStepDefinition(activeFlow));
  }
}
